module.exports = __webpack_public_path__ + "img/ytvd.050b139b.png";